module.exports = __webpack_public_path__ + "img/admin-2.bec5a797.jpg";